import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DashboardAnalyticsItem, Maybe } from '@libs/graphql-types';
import Typography from '@libs/ui/components/typography';

import DataBlock from '../data-block';
import BreakdownChart from './BreakdownChart';

interface BreakdownProps {
  categories: Maybe<DashboardAnalyticsItem>[];
  tags: Maybe<DashboardAnalyticsItem>[];
}

const Breakdown = ({ categories, tags }: BreakdownProps) => {
  const { t } = useTranslation('dashboard');
  const [type, setType] = useState<'categories' | 'tags'>('categories');
  const currentData = type === 'categories' ? categories : tags;

  return (
    <DataBlock fullHeight title={t('v1.myCommunityBy', { type })}>
      {type === 'categories' ? (
        <Typography
          pointer
          paragraph
          color="info.main"
          onClick={() => setType('tags')}
        >
          {t('v1.switchToTags')}
        </Typography>
      ) : (
        <Typography
          paragraph
          pointer
          color="info.main"
          onClick={() => setType('categories')}
        >
          {t('v1.switchToCategories')}
        </Typography>
      )}

      <BreakdownChart data={currentData} />
    </DataBlock>
  );
};

export default Breakdown;
